// https://shopify.dev/docs/api/usage/gids#parameterized-global-ids
const SHOPIFY_ID_REGEX = /^gid:\/\/shopify\/(?:[A-Za-z]+)\/(\d+(\?.+)?)$/;

export const shopifyGidToId = (gid: string) =>
  gid?.match(SHOPIFY_ID_REGEX)?.[1] ?? gid;
